<template>
  <div class="box collapsible-card" style="position: relative">
    <div class="card-header-wrapper" @click="toggleCard">
      <h1 class="title is-3 card-title">Current Subscription</h1>
      <div class="header-actions-desktop">
        <b-button
          v-if="!isForAdmin && subscription && !subscription.is_past_due"
          type="is-primary is-light"
          tag="router-link"
          :to="{ name: 'PlanList' }"
          @click.native.stop
        >
          Change Plan
        </b-button>
        <b-button
          v-if="!isForAdmin && subscription && subscription.is_past_due"
          type="is-primary is-light"
          @click.stop="onManageSubscription"
        >
          Update Payment
        </b-button>
      </div>
      <b-icon :icon="isExpanded ? 'chevron-up' : 'chevron-down'" class="toggle-icon"></b-icon>
    </div>
    <div class="header-actions-mobile" v-if="isExpanded">
      <b-button
        v-if="!isForAdmin && subscription && !subscription.is_past_due"
        type="is-primary is-light"
        tag="router-link"
        :to="{ name: 'PlanList' }"
        expanded
      >
        Change Plan
      </b-button>
      <b-button
        v-if="!isForAdmin && subscription && subscription.is_past_due"
        type="is-primary is-light"
        @click="onManageSubscription"
        expanded
      >
        Update Payment
      </b-button>
    </div>

    <div class="card-content-wrapper" :class="{ 'is-collapsed': !isExpanded }">
      <div
        v-if="subscription && subscription.is_past_due"
        class="notification is-danger is-light has-text-centered mb-0"
        style="border-radius: 0"
      >
        <span>
          Your subscription is past due. Please
          <a href="#" @click="onManageSubscription"><strong>Update Payment Method</strong></a>
          .
        </span>
      </div>

      <hr />
      <div v-if="subscription">
        <div class="columns">
          <div class="column">
            <p class="title is-4">Plan</p>
            <div class="block">
              <strong class="has-text-info">
                {{ subscription.user_plans.Base.Plan.name }}
                <span v-if="subscription.user_plans.Reimb">(w/ Reimbursements)</span>
                <span v-if="subscription.user_plans.BlanketVOB">
                  (w/ {{ subscription.user_plans.BlanketVOB.Plan.name }})
                </span>
                <span v-if="subscription.has_api_access">(w/API Access)</span>
              </strong>
              <br />
              Billed Monthly
              <br />
              <span>
                Inquiries: {{ subscription.base_used_quota }} used of
                {{ subscription.user_plans.Base.Plan.base_inquiries }}
              </span>
              <span>
                <br />
                Patient Verifier: {{ subscription.patient_verification_used_quota }} used of
                {{ subscription.user_plans.Base.Plan.patient_verifications }}
              </span>
              <span v-if="subscription.user_plans.BlanketVOB">
                <br />
                <span>
                  {{ subscription.user_plans.BlanketVOB.Plan.name }} :
                  {{ subscription.blanket_vob_used_quota }} used of
                  {{ subscription.user_plans.BlanketVOB.Plan.base_inquiries }}
                </span>
              </span>
              <span
                v-if="!subscription.user_plans.BlanketVOB && user && user.has_override_blanket_vob"
              >
                <br />
                <span>
                  Blanket VOB: {{ user.override_blanket_vob_used }} used
                  <span v-if="user.override_blanket_vob_limit > 0">
                    of {{ user.override_blanket_vob_limit }}
                  </span>
                  <span class="tag is-info is-light ml-2">Trial</span>
                </span>
              </span>
              <span v-if="subscription.user_plans.Reimb">
                <br />
                <span>Reimbursements: {{ subscription.reimbursement_used_quota }}</span>
              </span>
              <span v-else-if="user && user.has_override_reimbursement">
                <br />
                <span>
                  Reimbursements: {{ user.override_reimbursement_used }} used

                  <span class="tag is-info is-light ml-2">Trial</span>
                </span>
              </span>
            </div>
          </div>
          <div class="column">
            <p class="title is-4">Subscription</p>
            <div v-if="subscription.cancel_at_period_end">
              <strong class="has-text-danger">Your subscription will not renew.</strong>
              <br />
              Subscription ends: {{ subscription.cancel_at | formatDate }}
            </div>
            <div v-else>
              Your subscription will renew automatically.
              <br />
              Next bill date: {{ subscription.next_bill_date | formatDate }}
            </div>
          </div>
          <div class="column">
            <p class="title is-4">Payment Method</p>
            Type: {{ subscription.payment_method }}
            <br />
            <div v-if="subscription.payment_method.toLowerCase() == 'card'">
              {{ subscription.card_brand | title }} •••• {{ subscription.card_last4 }}
              <br />
              {{ subscription.card_holder }}
              <span v-if="subscription.card_holder">|</span>
              Expires: {{ subscription.card_exp_month }}/{{ subscription.card_exp_year }}
              <br />
            </div>
            <a href="#" v-if="!isForAdmin" @click="onManageSubscription">Update Payment Method</a>
            |
            <a href="#" v-if="!isForAdmin" @click="onManageSubscription">View Reciepts</a>
          </div>
        </div>
      </div>
      <div v-else>No Active Subscrition</div>
    </div>
  </div>
</template>

<script>
import request from '../request';

export default {
  name: 'SubscriptionDetail',
  props: {
    isForAdmin: {
      type: Boolean,
      default: false,
    },
    subscription: {
      required: false,
      type: Object,
    },
    user: {
      required: false,
      type: Object,
    },
  },
  data() {
    return {
      isExpanded: window.innerWidth > 1024,
      isMobile: window.innerWidth <= 1024,
    };
  },
  computed: {},
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    toggleCard() {
      if (this.isMobile) {
        this.isExpanded = !this.isExpanded;
      }
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 1024;
      if (!this.isMobile) {
        this.isExpanded = true;
      }
    },
    onManageSubscription() {
      this.loading = true;
      request.post('/subscriptions/portal-session').then((resp) => {
        window.location.href = resp.data.redirect_url;
      });
    },
  },
};
</script>

<style scoped>
.card-header-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.5rem 0;
}

.card-title {
  margin-bottom: 0 !important;
  flex-grow: 1;
}

@media (max-width: 1024px) {
  .collapsible-card {
    border-left: 4px solid #7957d5;
    margin-top: 1rem;
  }

  .card-header-wrapper {
    min-height: 1.5rem;
    padding: 0.1rem 0;
  }

  .card-title {
    font-weight: 600 !important;
    color: #363636;
  }
}

.header-actions-desktop {
  flex-shrink: 0;
}

.header-actions-mobile {
  display: none;
}

.toggle-icon {
  display: none;
  color: #6c757d;
  flex-shrink: 0;
}

.card-content-wrapper {
  overflow: hidden;
  transition:
    max-height 0.3s ease,
    opacity 0.3s ease;
  max-height: 2000px;
  opacity: 1;
}

@media (max-width: 1024px) {
  .card-header-wrapper {
    cursor: pointer;
  }

  .card-title {
    font-size: 1.25rem !important;
  }

  .header-actions-desktop {
    display: none;
  }

  .header-actions-mobile {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 0.75rem;
    margin-bottom: 0.25rem;
  }

  .toggle-icon {
    display: block;
  }

  .card-content-wrapper.is-collapsed {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
  }

  /* Compact subscription content on mobile */
  :deep(hr) {
    margin: 0.75rem 0;
  }

  :deep(.columns) {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  :deep(.columns .column) {
    padding: 0.5rem 0;
    margin-bottom: 0;
    width: 100% !important;
  }

  :deep(.columns .column .title.is-4) {
    font-size: 1rem !important;
    margin-bottom: 0.25rem !important;
  }

  :deep(.columns .column .block) {
    margin-bottom: 0 !important;
    font-size: 0.9rem;
    line-height: 1.4;
  }

  :deep(.notification) {
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
  }

  .collapsible-card {
    overflow-x: hidden;
  }
}
</style>
